// node modules
import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
// store
import { useStore } from 'modules/Stores';
// ui library
import { View } from '@upstox/upstox-ui';
// styles
import useCurrentHeight from 'utils/hooks/useCurrentHeight';
import * as css from './style';

export const FullScreenLayout: React.FC = observer(({ children }) => {
  const { dragging } = useStore('OptionChainStore');

  return (
    <Fragment>
      <View css={css.fullScreen} cssProps={{ height: useCurrentHeight() }}>
        {dragging && <View css={css.iFrameOverlay} />}
        {children}
      </View>
    </Fragment>
  );
});
